// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-role-manage .card-table-wrap[data-v-c68b6f44],.account-role-manage .card-table-wrap[data-v-c68b6f44] .card-table,.account-role-manage .card-table-wrap[data-v-c68b6f44] .el-empty{height:100%;min-height:var(--base-main-router-body-avaliable-height-with-action-bar)}", ""]);
// Exports
module.exports = exports;
